export default [
  {
    path: "/ranks",
    name: "ranks",
    component: () => import("@/views/ranks/ranks.vue"),
    meta: {
      title: "队伍",
    },
  },
  {
    path: "/myTeam",
    name: "myTeam",
    component: () => import("@/views/ranks/views/myTeam.vue"),
    meta: {
      title: "我的队伍",
    },
  },
  {
    path: "/addTeam",
    name: "addTeam",
    component: () => import("@/views/ranks/views/addTeam.vue"),
    meta: {
      title: "创建队伍",
    },
  },
  {
    path: "/ranksList",
    name: "ranksList",
    component: () => import("@/views/ranks/views/ranksList.vue"),
    meta: {
      title: "队伍排行",
    },
  },

  {
    path: "/teamAllMember",
    name: "teamAllMember",
    component: () => import("@/views/ranks/views/teamAllMember.vue"),
    meta: {
      title: "队员排行",
    },
  },
  {
    path: "/teamMember",
    name: "teamMember",
    component: () => import("@/views/ranks/views/teamMember.vue"),
    meta: {
      title: "队员排行",
    },
  },
  {
    path: "/teamAction",
    name: "teamAction",
    component: () => import("@/views/ranks/views/teamAction.vue"),
    meta: {
      title: "队伍行动",
    },
  },
  {
    path: "/addAction",
    name: "addAction",
    component: () => import("@/views/ranks/views/addAction.vue"),
    meta: {
      title: "发布行动",
    },
  },

  {
    path: "/rankDetails",
    name: "/rankDetails",
    component: () => import("@/views/ranks/views/rankDetails.vue"),
    meta: {
      title: "队伍详情",
    },
  },

  {
    path: "/ranks/teamTask",
    name: "/ranks/teamTask",
    component: () => import("@/views/ranks/views/teamTask.vue"),
    meta: {
      title: "队伍任务",
    },
  },

  {
    path: "/ranks/teamChange",
    name: "/ranks/teamChange",
    component: () => import("@/views/ranks/views/teamChange.vue"),
    meta: {
      title: "队伍交流",
    },
  },
  {
    path: "/ranks/teamArchives",
    name: "/ranks/teamArchives",
    component: () => import("@/views/ranks/views/teamArchives.vue"),
    meta: {
      title: "队伍档案",
    },
  },
  {
    path: "/ranks/teamEdit",
    name: "/ranks/teamEdit",
    component: () => import("@/views/ranks/views/teamEdit.vue"),
    meta: {
      title: "编辑队伍资料",
    },
  },
];
